import { useState } from "react";
import Table from "/src/components/table";
import phoneContextService from "/src/features/administration/telephonyLogs/services/phoneContextService";
import "../../TelephonyLogs.css";

const WARN_THRESHOLD = 0.5;
const CRITICAL_THRESHOLD = 0.8;

function usageRatio(current, max) {
    if (!max) return 0;
    return current / max;
}

function loadClass(current, max) {
    const ratio = usageRatio(current, max);
    if (ratio >= CRITICAL_THRESHOLD) return "telephony-log-level--error";
    if (ratio >= WARN_THRESHOLD) return "telephony-log-level--warn";
    return "telephony-log-level--info";
}

function PhoneCapacityTable({ refreshState }) {
    const [criticalPhones, setCriticalPhones] = useState([]);

    const cells = [
        { column: "Number", name: "number" },
        { column: "Current calls", name: "current_call", sort: true },
        { column: "Max simultaneous calls", name: "max_simultaneous_call", sort: true  },
        {
            column: "Load",
            name: ["current_call", "max_simultaneous_call"],
            show: ([current, max]) => (
                <span className={`telephony-log-level ${loadClass(current, max)}`}>
                    {current} / {max || "-"}
                    {max ? ` (${Math.round(usageRatio(current, max) * 100)}%)` : ""}
                </span>
            ),
            sort: true 
        },
    ];

    const filters = [{ type: "input", placeholder: "Number", name: "number" }];

    const onDataLoaded = (data) => {
        setCriticalPhones(data.filter((row) => usageRatio(row.current_call, row.max_simultaneous_call) >= CRITICAL_THRESHOLD));
    };

    return (
        <>
            {criticalPhones.length > 0 && (
                <div className="telephony-phone-alert">
                    <i className="fas fa-exclamation-triangle"></i>
                    <span>
                        {criticalPhones.length} number{criticalPhones.length > 1 ? "s" : ""} at {Math.round(CRITICAL_THRESHOLD * 100)}%+ capacity:{" "}
                        {criticalPhones.map((phone) => `${phone.number} (${phone.current_call}/${phone.max_simultaneous_call})`).join(", ")}
                    </span>
                </div>
            )}
            <Table
                name="phone" style={{ top: "0px" }} cells={cells} api={phoneContextService.getPhoneContext} actions={[]}
                buttons={[]} filters={filters} withPagination={false} refreshState={refreshState}
                defaultSort={{ column: "current_call", val: false }} onDataLoaded={onDataLoaded}
                silentRefresh={true}
            />
        </>
    );
}

export default PhoneCapacityTable;
